import type { ITimer } from 'atoms/Timer'
import type { IMultiColumnsItemProps } from '../../MultiColumnsItem'

import { Timer } from 'atoms/Timer'
import {
  MultiColumnsAlignItems,
  MultiColumnsJustifyContent,
} from '../../MultiColumns.h'
import { MultiColumnsItem } from '../../MultiColumnsItem'

export interface IPayPerViewTimer extends Omit<
  IMultiColumnsItemProps &
    Pick<ITimer, 'daysTitle' | 'hoursTitle' | 'minutesTitle' | 'secondsTitle'>,
  'children'
> {
  completionDate: string
  title?: string
  onTimerCompleted?: () => void
}

export const PayPerViewTimer = ({
  completionDate,
  title,
  justifyContent = MultiColumnsJustifyContent.FlexEnd,
  alignItems = MultiColumnsAlignItems.Center,
  onTimerCompleted,
  daysTitle,
  hoursTitle,
  minutesTitle,
  secondsTitle,
  ...rest
}: IPayPerViewTimer) => (
  <MultiColumnsItem
    justifyContent={justifyContent}
    alignItems={alignItems}
    {...rest}
  >
    <Timer
      title={title}
      daysTitle={daysTitle}
      hoursTitle={hoursTitle}
      minutesTitle={minutesTitle}
      secondsTitle={secondsTitle}
      completionDate={completionDate}
      onTimerCompleted={onTimerCompleted}
    />
  </MultiColumnsItem>
)
